import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import _fetchFlag from "./services/fetchFlag";
import fetchArrayFlags from "./utils/fetchArrayFlags";
import setFlagInObject from "./utils/setFlagInObject";
import setFlagsAsLoading from "./utils/setFlagsAsLoading";
export function createFeatureFlagStore(args) {
  return create()(devtools(function (set, get) {
    return {
      flags: {},
      metadata: {
        organizationId: args.organizationId,
        isOrganizationIdResolved: args.organizationId > 0
      },
      setMetadata: function setMetadata(metadata) {
        set({
          metadata: metadata
        });
      },
      getFlag: function getFlag(flagKey) {
        return get().flags[flagKey];
      },
      getFlagAndRegister: function getFlagAndRegister(flagKey, source) {
        var registeredFlag = get().getFlag(flagKey);
        if (!registeredFlag) {
          // Add flag to store and fetch its value
          get().fetchFlag(flagKey, source);

          // Retrieve flag from store (it should be there now after fetching)
          registeredFlag = get().getFlag(flagKey);
        }
        return registeredFlag;
      },
      setFlag: function setFlag(flagKey, flagValue, source) {
        var loading = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
        var error = arguments.length > 4 ? arguments[4] : undefined;
        set({
          flags: setFlagInObject(get().flags, {
            flagName: flagKey,
            flagValue: flagValue,
            loading: loading,
            apiVersion: source,
            error: error
          })
        });
      },
      setBatchFlags: function setBatchFlags(flags) {
        var newFlags = {};
        flags.forEach(function (flag) {
          newFlags = setFlagInObject(newFlags, {
            flagName: flag.flagName,
            flagValue: flag.flagValue,
            loading: flag.loading,
            apiVersion: flag.apiVersion,
            error: flag.error
          });
        });
        set({
          flags: _objectSpread(_objectSpread({}, get().flags), newFlags)
        });
      },
      fetchFlag: function () {
        var _fetchFlag2 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(flagKey, source) {
          var response, activatedFlag;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (get().metadata.isOrganizationIdResolved) {
                  _context.next = 3;
                  break;
                }
                get().setFlag(flagKey, false, source, true);
                return _context.abrupt("return");
              case 3:
                // Set flag 'loading' to true while fetching
                get().setFlag(flagKey, false, source, true);

                // Fetch flag value
                _context.next = 6;
                return _fetchFlag(flagKey, source, {
                  organizationId: get().metadata.organizationId
                });
              case 6:
                response = _context.sent;
                activatedFlag = response.flagValue; // Set flag value and 'loading' to false
                get().setFlag(flagKey, activatedFlag, source, false);
              case 9:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        function fetchFlag(_x, _x2) {
          return _fetchFlag2.apply(this, arguments);
        }
        return fetchFlag;
      }(),
      fetchAllFlags: function () {
        var _fetchAllFlags = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(flags) {
          var newFlags, responses;
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // Set all flags 'loading' to true while fetching
                newFlags = setFlagsAsLoading(flags);
                get().setBatchFlags(newFlags);

                // Skip network requests until organizationId is resolved
                if (get().metadata.isOrganizationIdResolved) {
                  _context2.next = 4;
                  break;
                }
                return _context2.abrupt("return");
              case 4:
                _context2.next = 6;
                return fetchArrayFlags(flags, get().metadata.organizationId);
              case 6:
                responses = _context2.sent;
                newFlags = responses.map(function (response) {
                  return {
                    flagName: response.flagKey,
                    flagValue: response.flagValue,
                    apiVersion: response.apiVersion,
                    error: response.error,
                    loading: false
                  };
                });
                get().setBatchFlags(newFlags);
              case 9:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        function fetchAllFlags(_x3) {
          return _fetchAllFlags.apply(this, arguments);
        }
        return fetchAllFlags;
      }()
    };
  }));
}